import { fetchApi } from '@/config/axiosSetting';
import { GetComplaintChartQueryResponseType } from './getComplaintChartQuery.type';

export const getComplaintChartFunction =
  (): Promise<GetComplaintChartQueryResponseType> => {
    return fetchApi.get('/survey/complaint_trend/');
  };
